/** 1 = Monday … 7 = Sunday */
export const STAFF_SCHEDULE_DAYS = [
  { value: 1, label: "Monday", short: "Mon" },
  { value: 2, label: "Tuesday", short: "Tue" },
  { value: 3, label: "Wednesday", short: "Wed" },
  { value: 4, label: "Thursday", short: "Thu" },
  { value: 5, label: "Friday", short: "Fri" },
  { value: 6, label: "Saturday", short: "Sat" },
  { value: 7, label: "Sunday", short: "Sun" },
];

/** Full role titles for tooltips / print */
export const STAFF_SCHEDULE_ROLE_TITLES = {
  RN: "Registered Nurse",
  LVN: "Licensed Vocational Nurse",
  CG: "Caregiver",
  CNA: "Certified Nursing Assistant",
  PT: "Physical Therapist",
  PTA: "Physical Therapist Assistant",
  OT: "Occupational Therapist",
  OTA: "Occupational Therapist Assistant",
  ST: "Speech Therapist",
  HHA: "Home Health Aide",
  MSW: "Medical Social Worker",
  CON: "Contractor",
  SRVY: "Surveyor",
};

/** Short code shown in the Position badge */
export const staffScheduleRoleShort = (role) => {
  const code = String(role || "").trim().toUpperCase();
  if (!code) return "—";
  if (code === "CON") return "CON";
  if (code === "SRVY") return "SRVY";
  return code;
};

/** Full label for print / accessibility */
export const staffScheduleRoleLabel = (role) => {
  const code = staffScheduleRoleShort(role);
  const title = STAFF_SCHEDULE_ROLE_TITLES[code];
  if (title) return `${code} — ${title}`;
  return code;
};

export const staffScheduleRoleTitle = (role) => {
  const code = staffScheduleRoleShort(role);
  return STAFF_SCHEDULE_ROLE_TITLES[code] || code;
};
